var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E9FFF3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "questionMark_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M12 12h32v32H12z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#questionMark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.933 36a1.61 1.61 0 0 0 1.183-.483 1.61 1.61 0 0 0 .484-1.184 1.61 1.61 0 0 0-.484-1.183 1.61 1.61 0 0 0-1.183-.483 1.61 1.61 0 0 0-1.183.483 1.61 1.61 0 0 0-.483 1.183c0 .467.16.861.483 1.184a1.61 1.61 0 0 0 1.183.483Zm-1.2-5.133H29.2c0-.734.083-1.312.25-1.734.166-.422.639-1 1.416-1.733.578-.578 1.034-1.128 1.367-1.65.334-.522.5-1.15.5-1.883 0-1.245-.455-2.2-1.366-2.867-.912-.667-1.99-1-3.234-1-1.267 0-2.294.333-3.083 1-.79.667-1.34 1.467-1.65 2.4l2.2.867c.11-.4.36-.834.75-1.3.389-.467.983-.7 1.783-.7.711 0 1.245.194 1.6.583.356.389.534.817.534 1.283 0 .445-.134.861-.4 1.25-.267.39-.6.75-1 1.084-.978.866-1.578 1.522-1.8 1.966-.223.445-.334 1.256-.334 2.434ZM28 41.333c-1.845 0-3.578-.35-5.2-1.05a13.465 13.465 0 0 1-4.233-2.85c-1.2-1.2-2.15-2.61-2.85-4.233-.7-1.622-1.05-3.356-1.05-5.2 0-1.845.35-3.578 1.05-5.2.7-1.622 1.65-3.033 2.85-4.233 1.2-1.2 2.61-2.15 4.233-2.85 1.622-.7 3.355-1.05 5.2-1.05 1.844 0 3.578.35 5.2 1.05 1.622.7 3.033 1.65 4.233 2.85 1.2 1.2 2.15 2.61 2.85 4.233.7 1.622 1.05 3.355 1.05 5.2 0 1.844-.35 3.578-1.05 5.2a13.465 13.465 0 0 1-2.85 4.233c-1.2 1.2-2.61 2.15-4.233 2.85-1.622.7-3.356 1.05-5.2 1.05Zm0-2.666c2.978 0 5.5-1.034 7.566-3.1 2.067-2.067 3.1-4.59 3.1-7.567 0-2.978-1.033-5.5-3.1-7.567-2.066-2.066-4.588-3.1-7.566-3.1-2.978 0-5.5 1.034-7.567 3.1-2.067 2.067-3.1 4.59-3.1 7.567 0 2.978 1.034 5.5 3.1 7.567 2.067 2.066 4.59 3.1 7.567 3.1Z",
    fill: "#26847A"
  }))));
};
export default SvgQuestionMark;